import React from "react";
import { Creator } from "../../../../api/staff";

interface CreatorEmailCellProps {
  creator: Creator;
}

const CreatorEmailCell: React.FC<CreatorEmailCellProps> = ({ creator }) => {

  return (
    <div className="flex flex-col gap-[6px] py-[8px]">
      <span className="text-[#11181C] text-[14px] font-medium">
        {creator.email}
      </span>
    </div>
  );
};

export default CreatorEmailCell;
